import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Collapse, Card, CardBody, CardTitle } from 'reactstrap';
import _ from 'lodash';
import { faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import Translate from '../../common/Translate';
import { alertsPresenter } from '../../../Utils/presenters/vincheck/alertsPresenter';

const NotificationsBloc = (vincheck) => {
  const [alerts] = useState(_.get(vincheck, `alerts`, null));
  const [isBlocOpen, setIsBlocOpen] = useState(true);
  const toggleBloc = () => setIsBlocOpen(!isBlocOpen);

  useEffect(() => {
    alertsPresenter(alerts);
  }, [alerts]);

  return (
    <Card className="card-window mt-4 mr-3 ml-4">
      <CardTitle>
        {alerts && alerts.length} <Translate code="notifications" />
        <FontAwesomeIcon
          className="text-corrected float-right"
          onClick={toggleBloc}
          icon={isBlocOpen ? faChevronUp : faChevronDown}
        />
      </CardTitle>
      <Collapse isOpen={isBlocOpen}>
        <CardBody>
          {alerts && alerts.map((alert) => <div className={`vincheck-alert ${alert.className}`}>{alert.text}</div>)}
        </CardBody>
      </Collapse>
    </Card>
  );
};

export default NotificationsBloc;
